import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { initAuth } from '../../app-main/actions/auth';
import BookingRequestContainer from '../../app-main/containers/BookingRequest';

class AddServicesIOSModal extends Component {
  constructor (props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.scrollTopIOS = this.scrollTopIOS.bind(this);
  }

  componentDidMount () {
    const { dispatch, accessToken } = this.props;
    dispatch(initAuth(accessToken));
  }

  closeModal () {
    const parentNode = document.getElementById('concierge-container');
    const nodes = document.getElementsByClassName('concierge-modal-ios');

    parentNode.removeChild(nodes[0]);
  }

  scrollTopIOS () {
    const modal = document.getElementById('add-services-page-modal');
    if (modal) {
      modal.scrollTo(0, 0);
    }
  }

  renderBody () {
    const { accessToken } = this.props;
    if (accessToken) {
      return (
        <BookingRequestContainer
          {...this.props}
          token={accessToken}
          closeIOSModal={this.closeModal}
          scrollTopIOS={this.scrollTopIOS}
          closeModal={this.closeModal}
          iosWebView
        />
      );
    }
  }

  render () {
    const { accessToken } = this.props;

    return (
      <div id="concierge-container">
        <div className="concierge-modal-ios">
          {
            accessToken &&
              <BookingRequestContainer
                {...this.props}
                token={accessToken}
                closeIOSModal={this.closeModal}
                scrollTopIOS={this.scrollTopIOS}
                closeModal={this.closeModal}
                iosWebView
              />
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    ...state
  };
}

AddServicesIOSModal.propTypes = {
  accessToken: PropTypes.string,
  iosWebView: PropTypes.bool,
  dispatch: PropTypes.func
};

export default connect(mapStateToProps)(AddServicesIOSModal)
